import { render, staticRenderFns } from "./ProfilePhotoLayout.vue?vue&type=template&id=bfc32180&scoped=true"
import script from "./ProfilePhotoLayout.vue?vue&type=script&lang=js"
export * from "./ProfilePhotoLayout.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhotoLayout.vue?vue&type=style&index=0&id=bfc32180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc32180",
  null
  
)

export default component.exports